import { Component, AfterViewInit, OnInit } from '@angular/core';
import { AddThisService } from './addthis.service';

@Component( {
  selector: 'addthis',
  template: '<div class="sharethis-inline-share-buttons" [attr.data-url]="currentUrl" data-email-subject="Ich möchte einen Link mit dir teilen."> </div>'
} )
export class AddThisComponent implements AfterViewInit, OnInit {
  public currentUrl: string;
  constructor(
    private addThisSvc: AddThisService,
  ) {}

  ngOnInit() {
    this.currentUrl = window.location.href;
  }

  ngAfterViewInit() {
      setTimeout(() => {
        this.addThisSvc.refresh();
      }, 100);
  }
}
